var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:("" + (_vm._isThemeGame ? 'toggle-game game-toggle-select' : 'toggle'))},_vm._l((_vm.options),function(name,key){return _c('a',{key:key,class:[
      _vm.value === key && 'active',
      _vm.value === key && _vm._isThemeGame ? 'game-border-toggle-active' : ''
    ],domProps:{"textContent":_vm._s(_vm.$t(("" + name)))},on:{"click":function($event){_vm.value !== key && _vm.$emit('select', key)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }